import React from "react"
import { Link } from "gatsby"
import style from "./mainnav.module.css"

const MainNav = ({ title, main }) => {
  return (
    <nav className={style.navigation}>
      {main ? (
        <Link to="/">
          <h1 className="main-heading text-pattern pattern-zigzag-sm">{title}</h1>
        </Link>
      ) : (
        <Link className="header-link-home" to="/">
          <h1 className="main-heading text-pattern pattern-triangles-sm">
            {title}
          </h1>
        </Link>
      )}
    </nav>
  )
}

export default MainNav
